import { ServerValueEnum } from '../../utils/enum';

const PresenceStatus = new ServerValueEnum({
  UNKNOWN: { serverValue: 'unknown' },
  AVAILABLE: { serverValue: 'online' },
  UNAVAILABLE: { serverValue: 'offline' },
} as const);

export default PresenceStatus;
